var e=function(){function e(){}return e.prototype.sleep=function(e){return new Promise((function(t){return setTimeout(t,1e3*e)}))},e}();export{e as default};
